module.exports = __webpack_public_path__ + "img/guide_common_01.12f5e74d.png";